import isArray from 'lodash/isArray';

import getFilterWithCol from '../../helpers/getFilterWithCol';
import clickAnchor from '../../helpers/clickAnchor';

import tests from '../../helpers/tests';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { name: { REGEX: value, OPTIONS: 'i' } },
        { email: { REGEX: value, OPTIONS: 'i' } },
      ],
    },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search customer name or email',
  }],
}];

const getValueForFieldDefault = value => (
  value && value.length
  ? value
  : undefined
);

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  col: 12,
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Find By Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  build: builder => {
    builder.add('populate', { store: {
      _id: true,
      name: true,
      systemCountry: true,
    } });
    builder.add('populate', { customer: {
      _id: true,
      name: true,
      email: true,
      phoneNumber: true,
      systemCountry: true,
    } });
    return builder;
  },
}];

export const filterScopeToSellerStore = ['FilterHidden', {
  id: 'scopeToSellerStore',
  build: builder => builder.add('custom', { scopeToSellerStore: true }),
}];

export const filterSort = (values => ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  VALUES_MAP: values.reduce(
    (agr, [key, , value]) => {
      agr[key] = value;
      return agr;
    },
    {},
  ),
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('sort', { ...filter.VALUES_MAP[value] })
    : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: values.map(([key, label]) => ({ label, value: key })),
  }],
}])([
  ['createdDesc', '↓ Date Created', { createdAt: -1 }],
  ['createdAsc', '↑ Date Created', { createdAt: 1 }],
  ['updatedDesc', '↓ Date Updated', { updatedAt: -1 }],
  ['updatedAsc', '↑ Date Updated', { updatedAt: 1 }],
  ['lastSentDesc', '↓ Last Sent', { lastSentAt: -1 }],
  ['lastSentAsc', '↑ Last Sent', { lastSentAt: 1 }],
]);

export const filterExport = ['FilterField', {
  id: 'export',
  name: 'export',
  label: null,
  section: 'top',
  buildQuery: () => { },
  propsFromPage: ({ client, queryBuilder, restBaseServer }) => ({
    client,
    queryBuilder,
    restBaseServer,
  }),
  skip: [tests.viewerIsAdminAndDoesNotHavePermission('reportsExport')],
  field: ['Action', {
    name: 'export',
    icon: 'download',
    title: 'Export Abandoned Carts',
    type: 'default',
    style: { width: '100%' },
    onClick: (props) => clickAnchor({
      url: `${props.restBaseServer}/abandoned-carts/export`,
      query: {
        access_token: props.client.getAccessToken(),
        query: props.queryBuilder.compile(),
      },
    }),
  }],
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterSort, 12],
    [filterStore, 24],
    [filterExport, 24],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
];

export const SELLER = [
  ...[
    [filterSearch, 12],
    [filterSort, 12],
    [filterExport, 24],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
  filterScopeToSellerStore,
];
